import FileIcon from 'components/Icons/File';
import { StdListCheckbox, StdListRow } from 'components/StdList';
import React, { CSSProperties, ReactElement } from 'react';

interface Props {
  name: string;
  id: string;
  isChecked: boolean;
  fileSelected: (name: string, isChecked: boolean) => void;
  style: CSSProperties;
}

const ConfirmUploadsListRow = (props: Props): ReactElement => {
  const { name, id, isChecked, fileSelected, style } = props;

  const rowId = `confirm-upload-list-row-${id}`;

  return (
    <StdListRow
      id={`${rowId}-cell`}
      noHover
      onClick={() => fileSelected(name, !isChecked)}
      style={style}
    >
      <StdListCheckbox
        rowId={id}
        onChange={() => fileSelected(name, !isChecked)}
        checked={isChecked}
      />
      <div id={`${rowId}-cell-name`} className="row items-center pl3">
        <FileIcon />
        <div className="ml2">{name}</div>
      </div>
    </StdListRow>
  );
};

export default ConfirmUploadsListRow;
